import React, { Component } from 'react';
import * as d3 from 'd3';
import "./personalityavatar.css";


class PersonalityAvatar extends Component {
  constructor(props){
      super(props);
      //this.allVillagers = this.props.villagers;
   }
  render() {

    let personality = this.props.personality,
        bgColor = this.props.personalityColor;

    let labelImg = personality;

    return (
      <div className="avatar personality-avatar">
          <img style={{backgroundColor: '#ffffff', borderColor:bgColor}} src={process.env.PUBLIC_URL + `/images/personality/${labelImg}.png`} alt="Avatar" />
          <b className="avatar-label">{personality}</b>
      </div>

    )
  }
}

export default PersonalityAvatar;
